import flatten from 'flat';
import workspace from './en-US/workspace';

export default flatten({
  ...workspace,
});
